import {useEffect, useRef} from "react";
import ResizeObserver from 'resize-observer-polyfill';

type windowResizeCallback = (contentRect?: DOMRectReadOnly) => any;


/**
 * 窗口尺寸发生变化时触发的钩子
 * @param handler
 */
const useWindowResize = (callback?: windowResizeCallback) => {
	const observerRef = useRef<any>(null);


	useEffect(() => {
		init();
		return () => {
			if (observerRef.current) {
				observerRef.current.unobserve(document.body);
			}
		}
	}, []);


	/**
	 * 初始化
	 */
	const init = () => {
		observerRef.current =  new ResizeObserver((entries: ResizeObserverEntry[]) => {
			if (!entries || entries.length === 0) {
				return;
			}
			const { contentRect }: any = entries[0];
			if (callback) {
				callback(contentRect);
			}
		});
		observerRef.current.observe(document.body);
	}

	return null;
}


export default useWindowResize;
